<template>
  <div>
    <!-- Confirm modal -->
    <ConfirmationModal
      ref="confirmationModal"
      :title="confirmationTitle"
      :subtitle="confirmationSubtitle"
      :message="confirmationMessage"
      confirmColor="error darken-1"
    />
    
    <v-dialog
      width="600px"
      persistent
      v-model="dialog"
      overlay-opacity="0.9"
    >
      <v-card  tile>
        <v-card-title>Assignment Options</v-card-title>
        <v-card-text>
        <p>Please select one of the options below to continue.</p> 
        <v-container fluid>
          <v-row>
            <v-col col="4" class="d-flex align-stretch">
              <v-card
                hover
                outlined
                style="width: 100%" 
                class="px-2 py-3 shadow text-center" 
                @click="assignmentToSelf()" > 
                <v-icon size="2.5em">mdi-hand-pointing-up</v-icon>
                <p>Assign to Self</p>   
              </v-card>
            </v-col>
            
            <v-col col="4" class="d-flex align-stretch">
              <v-card 
                hover
                outlined
                style="width: 100%" 
                class="px-2 py-3 shadow text-center" 
                @click="assignmentToOtherUsers()"> 
                
                <v-icon size="2.5em">mdi-account-multiple-outline</v-icon>
                <p>Assign to another officer</p>   
              </v-card>
            </v-col>
            <v-col col="4" class="d-flex align-stretch">
              <v-card
                hover
                outlined
                style="width: 100%" 
                class="px-2 py-3 shadow text-center" 
                @click="sendToPool()"> 
                <v-icon size="2.5em">mdi-table</v-icon>
                <p>Send to Pool</p>   
              </v-card>
            </v-col>
          </v-row>
        </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    
    <!-- Loan assignment modal -->
    <LoanAssignmentModal
      @refresh="dialog = false; this.$emit('closed')"
      ref="loanAssignmentModal"
    />
  </div>
</template>

<script>
import PageMixin from '@/mixins/page.mixin';
import SocketMixin from '@/modules/loanpro/mixins/socket.mixin';
import { LoanPoolService } from '@/modules/loanpro/services/loan-pool.service';
import LoanAssignmentModal from '@/modules/loanpro/components/loan-pro/LoanAssignmentModal.vue';

export default {
  mixins: [PageMixin, SocketMixin],

  components: {
    LoanAssignmentModal,
  },
  
  data() {
    
    return {
      loan: {},
      dialog: false,

      // Confirmation modal options
      confirmationTitle: '',
      confirmationMessage: '',
      confirmationSubtitle: '',
      
      /**
       * If set to true, this indicates if socket mixin should ignore the listener
       */
      useSocketEmitOnly: true
    };
      
  },

  methods: {
    
    /**
     * Close component dialog
     */
    closeDialog()  {
      this.loan = null;
      this.dialog = false;
    },

    /**
     * Gets call when the component is cloased 
     */
    onEmitClosed() {
      this.closeDialog(); 
      
      /**
       * Triggerd when the component is closed 
       *
       * @event closed
       */
      this.$emit('closed');
    },

    /**
     * Open component dialog
     * 
     * @param { Object } loan - the loan to assign
     */
    openDialog(loan)  {
      this.loan = loan;
      this.dialog = true;
    },

    /**
     * Send loan to pool without assigning it 
     */
    sendToPool()  {
      this.dialog = false;
      this.onEmitClosed();
      this.showSnack({
        color: 'success',
        title: `Loan was sent to pool`,
        message: `Check the loan pool for the loan you just created.`
      });
    },
    
    /**
     * Open modal to assign loan to another user 
     */
    assignmentToOtherUsers() {
      this.$refs.loanAssignmentModal.openModal(this.loan);
      this.onEmitClosed();
    },

    /**
     * Assign loan to current user 
     */
    assignmentToSelf() {
      this.confirmationTitle = 'Confirm action';
      this.confirmationMessage = `Are you sure you want to assign this loan to yourself?`;

      this.$refs.confirmationModal.show(async () => {
        try {
          const service = new LoanPoolService();
          await service.assignLoanToUser({
            loanId: this.loan.id,
            userId: this.user?.id
          });

          this.showSnack({
            color: 'success',
            title: `Loan Assigned`,
            message: `Loan was assigned to you.`
          });
          
          this.emitAssignLoanToSelfEvent(this.loan);

          this.onEmitClosed();
        } catch (error) {
          this.showSnack({
            color: 'error',
            title: `Failed to Assign`,
            message: `Failed to assign the loan to you. Please try again.`
          });
        }
      });
    }
 
  }
};
</script>
